import { Link } from 'react-router-dom';
import cssIf from '../../../scripts/helpers/class.add.if';

import './button.scss';

const Button = ({ children, action = false, disabled = false, color = 'green', className = '' }) => {

  return (

    <button 

      onClick = { () => { action && action() }}
      className = { `flex center items-center button button--${ color } button--${ cssIf( disabled, 'disabled' ) } ${ className }`}
      
    >

      { children }

    </button>

  );

};

export const ButtonRouter = ( props ) => (

  <Link to = { props.url }>
    <Button { ...props }/>
  </Link>
  
)

export default Button;